import React from "react";

import { EntityType } from "@mapmycustomers/shared/enum";

import IMapViewContext from "@app/component/view/types/IMapViewContext";

// Create view context with some default values
// This is base map view context, originally intended for use in Map mode
// Other modes can extend it with additional functionality
const BaseMapViewContext = React.createContext<IMapViewContext>({
  updateFilterModel: () => {},
  updateViewAs: () => {},
  updateViewState: () => {},
  updateViewStateAndFetch: () => {},
  viewState: {
    columns: [],
    filter: {},
    range: { endRow: 0, startRow: 0 },
    sidebarVisible: false,
    sort: [],
    tool: undefined,
    viewAs: undefined,
    visibleEntities: [EntityType.COMPANY, EntityType.PERSON, EntityType.DEAL],
  },
});

export default BaseMapViewContext;
